"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var PageManager = exports["default"] = /*#__PURE__*/function () {
  function PageManager() {
    (0, _classCallCheck2["default"])(this, PageManager);
    this.init();
  }
  return (0, _createClass2["default"])(PageManager, [{
    key: "init",
    value: function init() {
      this.onPageLoad();
    }
  }, {
    key: "onPageLoad",
    value: function onPageLoad() {
      console.warn("onPageLoad() should be implemented by subclasses");
    }
  }]);
}();
//# sourceMappingURL=page-manager.js.map
